export const LOCAL_ORIGIN = Symbol('storydoc.yjs.local');
export const REMOTE_ORIGIN = Symbol('storydoc.yjs.remote');
export const DERIVED_ORIGIN = Symbol('storydoc.yjs.derived');

export type YjsTransactionOrigin =
  | typeof LOCAL_ORIGIN
  | typeof REMOTE_ORIGIN
  | typeof DERIVED_ORIGIN
  | unknown;

export const isLocalOrigin = (origin: YjsTransactionOrigin) => origin === LOCAL_ORIGIN;
